// import Layout from '@/layout'
import BasicLayout from '@/layout/BasicLayout.vue'

const consoleRouter = {
  path: '/platform',
  component: BasicLayout,
  children: [
    {
      path: '/platform/system-data',
      component: () => import('../../views/console/index.vue'),
      children: [
        {
          path: '/platform/system-data/client-manage',
          component: () => import('../../views/console/client/index.vue'),
        },
        {
          path: '/platform/main-data/user-management',
          component: () => import('../../views/console/user/index.vue'),
        },
        {
          path: '/platform/main-data/role-management',
          component: () => import('../../views/console/role/index.vue'),
        },
        {
          path: '/platform/main-data/employee-management',
          component: () => import('../../views/console/employee/index'),
        },
        {
          path: '/platform/main-data/workstation-management',
          component: () => import('../../views/console/workstation/index'),
        },
        {
          path: '/platform/main-data/workstation-group',
          component: () => import('../../views/console/workstation-group/index'),
        },

        {
          path: '/platform/main-data/process-management',
          component: () => import('../../views/console/process/index'),
        },
        {
          path: '/platform/main-data/board-gallery',
          component: () => import('../../views/console/board-gallery/index.vue'),
        },
        {
          path: '/platform/main-data/organization-position',
          component: () => import('../../views/console/organization-position/index.vue'),
        },
      ],
    },
    {
      path: '/platform/page_control',
      component: () => import('../../views/console/control/index.vue'),
    },
    {
      path: '/platform/workstation-maintain',
      component: () => import('../../views/console/workstation-maintain/index'),
    },

    {
      path: '/platform/edge-data',
      component: () => import('../../views/console/index.vue'),
      children: [
        {
          path: '/platform/edge-data/batch-management',
          component: () => import('../../views/console/batch-management/index'),
        },
        {
          path: '/platform/edge-data/terminal',
          component: () => import('../../views/console/terminal/index.vue'),
        },
        {
          path: '/platform/edge-data/devices-management',
          component: () => import('../../views/console/devices-management/index'),
        },
        {
          path: '/platform/edge-data/firmware-management',
          component: () => import('../../views/console/firmware-management/index'),
        },
        {
          path: '/platform/edge-data/log-management',
          component: () => import('../../views/console/log-management/index'),
        },
      ],
    },
    {
      path: '/platform/biz-data',
      component: () => import('../../views/console/index.vue'),
      children: [
        {
          path: '/platform/main-data/user-management',
          component: () => import('../../views/console/user/index.vue'),
        },
      ],
    },
    {
      path: '/platform/iot-console',
      component: () => import('../../views/console/index.vue'),
      children: [
        {
          path: '/platform/iot-console/batch-management',
          component: () => import('../../views/console/iot-batch-management/index'),
        },
        {
          path: '/platform/iot-console/gateway-list',
          component: () => import('../../views/console/gateway-list/index.vue'),
        },
        {
          path: '/platform/iot-console/firmware-management',
          component: () => import('../../views/console/firmware-management/index'),
        },
        {
          path: '/platform/iot-console/log-management',
          component: () => import('../../views/console/log-management/index'),
        },
        {
          path: '/platform/iot-console/gateway-admin',
          component: () => import('@/views/iot-console/gateway-admin/index.vue'),
        },
        {
          path: '/platform/iot-console/comp',
          component: () => import('../../views/iot-console/comp/index.vue'),
        },
        {
          path: '/platform/iot-console/terminal',
          component: () => import('../../views/console/terminal/index.vue'),
        },
        {
          path: '/platform/iot-console/gateway-analysis',
          component: () => import('../../views/console/gateway-analysis/index'),
        },
        {
          path: '/platform/iot-console/remote-terminal',
          // component: () => import('../../views/console/remote-terminal/index.vue'),
          component: () => import('../../views/console/remote-terminal-node/index.vue'),
        },
        {
          path: '/platform/iot-console/pad-desktop',
          component: () => import('../../views/console/pad-desktop/index.vue'),
        },
        {
          path: '/platform/iot-console/iot-map',
          component: () => import('../../views/console/iot-map/index.vue'),
        },
        {
          path: '/platform/iot-console/remote-connect-manage',
          component: () => import('../../views/console/remote-connect-manage/index.vue'),
        },
      ],
    },

    {
      path: '/platform/main-data2',
      component: () => import('../../views/console/index.vue'),
      children: [        
        {
          path: '/platform/main-data/workstation-group2',
          component: () => import('../../views/console/workstation-group/index'),
        },
        {
          path: '/platform/workstation-maintain2',
          component: () => import('../../views/console/workstation-maintain/index'),
        },
        {
          path: '/platform/main-data/production-calendar2',
          component: () => import('../../views/console/production-calendar'),
        },
        {
          path: '/platform/main-data/shift-model2',
          component: () => import('../../views/console/shift-model'),
        },
      ]
    },
    {
      path: '/platform/main-data',
      component: () => import('../../views/console/index.vue'),
      children: [
        {
          path: '/platform/main-data/shift-off-day',
          component: () => import('../../views/console/shift-off-day/index.vue')
        },
        {
          path: '/platform/main-data/user-management',
          component: () => import('../../views/console/user/index.vue'),
        },
        {
          path: '/platform/main-data/role-management',
          component: () => import('../../views/console/role/index.vue'),
        },
        {
          path: "/platform/main-data/supplier-information",
          component: () =>
            import("../../views/console/supplierInformation/index"),
        },
        {
          path: "/platform/main-data/customer-information",
          component: () =>
            import("../../views/console/customerInformation/index"),
        },
        // 登录日志修改
        // {
        //   path: "/platform/main-data/operation-log",
        //   component: () => import("../../views/console/operation-log/index"),
        // },
      ],
    },
    {
      path: '/platform/tenant',
      component: () => import('../../views/console/tenant/index.vue'),
    },
    {
      path: '/platform/personal',
      component: () => import('../../views/console/personal-center/index.vue'),
    },
    {
      path: '/platform/notification-center',
      component: () => import('../../views/console/index.vue'),
      children: [
        {
          path: '/platform/notification-center/notification-configuration',
          component: () => import('../../views/console/notification-configuration/index.vue'),
        },
        {
          path: '/platform/notification-center/notification-rule',
          component: () => import('../../views/console/notification-rule/index.vue'),
        },
        {
          path: '/platform/notification-center/notification-edition',
          component: () => import('../../views/console/notification-edition/index.vue'),
        },
        {
          path: '/platform/notification-center/notification-template',
          component: () => import('../../views/console/notification-template/index.vue'),
        },
        {
          path: '/platform/notification-center/notification-method',
          component: () => import('../../views/console/notification-method/index.vue'),
        },
      ]
    },
    {
      path: '/platform/system',
      component: () => import('../../views/console/ops/index.vue'),
      children: [
        {
          path: '/platform/system/system-management',
          component: () => import('../../views/console/ops/app/index.vue'),
        },
        {
          path: '/platform/system/menu',
          component: () => import('../../views/console/ops/app-menu/index.vue'),
        },
        // {
        //   path: '/platform/system-data/bill-settings',
        //   component: () => import('../../views/console/bill-settings/index'),
        // },
        {
          path: '/platform/system-data/bill-manage',
          component: () => import('../../views/console/bill-manage/index.vue'),
        },
        {
          path: '/platform/system-data/bill-classify',
          component: () => import('../../views/console/bill-classify/index.vue'),
        },
        {
          path: '/platform/system/menu-management',
          component: () => import('../../views/console/ops/menu/index.vue'),
          name: 'menu-manage',
        },
        {
          path: '/platform/system/app-authorization',
          component: () => import('../../views/console/ops/app-auth/index.vue'),
          name: 'app-authorization',
        },
        // {
        //   path: '/platform/system/theme',
        //   component: () => import('../../views/console/appearance/index.vue'),
        // },
        {
          path: '/platform/system/card-manage',
          component: () => import('../../views/console/ops/card/index.vue'),
        },
        {
          path: '/platform/system/language-management',
          component: () => import('../../views/console/language/index.vue'),
        },
        {
          path: "/platform/system/interface-setting",
          component: () =>
            import("../../views/console/interface-setting/index.vue"),
        },
        {
          path: '/platform/system/coding-rules',
          component: () => import('../../views/console/coding-rules/setting.vue'),
          children: [
            {
              path: '/platform/system/coding-rules/list',
              component: () => import('../../views/console/coding-rules/index'),
            },
            {
              path: '/platform/system/coding-rules/mapping',
              component: () => import('../../views/console/coding-rules/index'),
            }
          ]
        },
        {
          path: '/platform/system/client-manage',
          component: () => import('../../views/console/client/index.vue'),
        },
        {
          path: '/platform/system/param-manage',
          component: () => import('../../views/console/param/index.vue'),
        },
        {
          path: '/platform/system/dict-manage',
          component: () => import('../../views/console/dict/index.vue'),
        },
        {
          path: '/platform/system/oss-manage',
          component: () => import('../../views/console/oss/index.vue'),
        },
        {
          path: '/platform/system/biz-dict-manage',
          component: () => import('../../views/console/dictBiz/index.vue'),
        },
      ],
    },
    {
      path: '/platform/iot-console',
      component: () => import('../../views/console/index.vue'),
    },
    {
      path: '/platform/authority',
      component: () => import('../../views/console/authority/index.vue'),
    },
    {
      path: '/platform/business-data',
      component: () => import('../../views/console/index.vue'),
      children: [
        {
          path: '/platform/product-main-data',
          component: () => import('../../views/console/business-data/index.vue'),
        },
        {
          path: '/platform/device-main-data',
          component: () => import('../../views/console/business-data/index.vue'),
        },
        {
          path: '/platform/material-main-data',
          component: () => import('../../views/console/business-data/index.vue'),
        },
        {
          path: '/platform/quality-main-data',
          component: () => import('../../views/console/business-data/index.vue'),
        }
      ],
    },
    {
      path: '/platform/menu-maintenance',
      component: () => import('../../views/console/menu/index'),
    },
    {
      path: '/platform/main-data/production-calendar',
      component: () => import('../../views/console/production-calendar'),
    },

    {
      path: '/platform/main-data/shift-model',
      component: () => import('../../views/console/shift-model'),
    },

    {
      path: "/platform/main-data/operation-log",
      component: () => import("../../views/console/operation-log/index"),
    },
    {
      path: '/platform/system/theme',
      component: () => import('../../views/console/appearance/index.vue'),
    },
  ],
}

export default consoleRouter
